export const EMPLOYER_GET_ALL = "V1_EMPLOYER_GET_ALL";
export const CREATE_EMPLOYER = "V1_CREATE_EMPLOYER";
export const UPDATE_EMPLOYER = "V1_UPDATE_EMPLOYER";
export const GET_EMPLOYER_LIST_NO_COID = "V1_GET_EMPLOYER_LIST_NO_COID";
export const UPDATE_REMARKCOUNT_EMPLOYER = "V1_UPDATE_REMARKCOUNT_EMPLOYER";
